import { useEffect, useId, useRef } from 'react'
import type { ShortcutDefinition } from './KeyboardShortcutContext'
import { useKeyboardShortcutContext } from './KeyboardShortcutContext'

export const useKeyboardShortcut = (shortcut: ShortcutDefinition) => {
  const { registerShortcut, unregisterShortcut } = useKeyboardShortcutContext()
  // Names this hook instance, so unmounting drops only its own registration of the id.
  const registrant = useId()
  const shortcutRef = useRef(shortcut)
  shortcutRef.current = shortcut

  useEffect(() => {
    // Read the id now: by cleanup time `shortcutRef.current` already holds the next id.
    const { id } = shortcutRef.current
    registerShortcut(shortcutRef.current, registrant)
    return () => unregisterShortcut(id, registrant)
  }, [shortcut.id, registrant, registerShortcut, unregisterShortcut])

  // Keep the action and enabled state up-to-date without triggering re-registration
  useEffect(() => {
    registerShortcut(shortcutRef.current, registrant)
  }, [shortcut.action, shortcut.enabled, registrant, registerShortcut])
}
